import "core-js/modules/es.array.push.js";
import { Dialog, DialogPanel, DialogTitle, TransitionRoot, TransitionChild } from "@headlessui/vue";
// import { nextTick } from "vue";

export default {
  name: "FAQDialog",
  data: () => ({
    isOpen: false
  }),
  components: {
    Dialog,
    DialogPanel,
    DialogTitle,
    TransitionRoot,
    TransitionChild
  },
  watch: {
    "$route.hash"(newHash) {
      if (newHash === "#faq" && this.isOpen == false) {
        this.isOpen = true;
      } else {
        this.isOpen = false;
      }
    }
  },
  computed: {
    faq() {
      if (this.$i18n.locale === 'zh') {
        return [{
          "q": "为什么email收不到报告呢？",
          "a": "我们的email是会发出的，这个我们检测过了，你收不到可能是你的邮箱系统把我们当成垃圾或病毒给屏蔽了，你可以去垃圾箱里找一找看看有没有我们给你发的邮件。如果垃圾箱里也没有，你就换一个邮箱试试，比如你可以从gmail换成hotmail，看看是否还收不到。如果再收不到，你就到“意见反馈”栏里提交一下你的问题，并且附上你的邮箱后缀名，我们就知道谁把我们屏蔽了。"
        }, {
          "q": "为什么我生成的文件是空的？",
          a: "因为文件还没下载完，你就把它打开了，下次生成完，你等个30秒左右，再去打开这个文件，就正常了。"
        }, {
          "q": "为什么缺乏中文文献？",
          a: "我们是通过万方数据API搜索中文文献，现在用户太多了，我们的额度用完了，正在申请扩容中。一旦解决，会在公告栏告诉大家。"
        }, {
          "q": "为什么生成内容与输入主题不相关？",
          a: "这种情况极少发生，如果出现了，大部分可能性是跟你主题相关的学术参考文献太少，要么你换一个生成要求试一试。"
        }];
      } else {
        return [{
          q: "Why can't I receive the report via email?",
          a: "Our email will be sent out, and we have checked it. If you cannot receive it, it may be because your email system has blocked us as spam or a virus. You can check the spam folder to see if there are any emails we sent to you. If there's nothing in the trash can, try changing your email, such as switching from Gmail to Hotmail, and see if you still can't receive it. If you can't receive it again, please submit your question in the \"Feedback\" column and attach your email extension, and we will know who blocked us."
        }, {
          q: "Why is the file I generated empty?",
          a: "Because the file hasn't been downloaded yet, you opened it. After generating it next time, you can wait for about 30 seconds before opening the file, and it will be normal."
        }, {
          q: "Why is there a lack of Chinese literature?",
          a: "We are searching for Chinese literature through the Wanfang Data API. There are too many users now, and our quota has been exhausted. We are currently applying for expansion. Once resolved, we will inform everyone on the bulletin board."
        }, {
          q: "Why is the generated content unrelated to the input topic?",
          a: "This situation rarely occurs, and if it does, most likely it is due to a lack of academic references related to your topic, or you can try a different generation requirement."
        }];
      }
    }
  },
  methods: {
    closeDialog(e) {
      this.$router.push('');
      // this.isOpen = false
    },
    pushHash(v) {
      this.$router.push({
        hash: v
      });
      this.isOpen = true;
    },
    handleHashChange() {
      // console.log(123,)
      if (this.$route.hash === '#faq') {
        this.isOpen = true;
      }
    }
  },
  mounted() {
    this.handleHashChange();
  }
};